import { selectProcedureStepById, selectProcedureStepFieldsById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { procedureStepFieldsRevisionSettingsDetailViewStaticData } from "src/views/ProcedureStepFieldsRevisionSettingsDetailView/constants"
import { ProcedureStepFieldsRevisionSettingsDetailView } from "src/views/ProcedureStepFieldsRevisionSettingsDetailView/ProcedureStepFieldsRevisionSettingsDetailView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/$procedureStepId/revisions/$procedureStepFieldsId",
)({
	component: ProcedureStepFieldsRevisionSettingsDetailView,
	staticData: procedureStepFieldsRevisionSettingsDetailViewStaticData,
	loader: ({ params }) => {
		const procedureStep = selectProcedureStepById(params.procedureStepId)(appStore.getState())
		const procedureStepFields = selectProcedureStepFieldsById(params.procedureStepFieldsId)(appStore.getState())

		if (
			!procedureStep ||
			procedureStep.procedure_type !== params.procedureTypeId ||
			!procedureStepFields ||
			procedureStepFields.procedure_step !== procedureStep.uuid
		) {
			throw notFound()
		}
	},
})
